var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styleDiv),attrs:{"id":"container"}},[_c('img',{ref:"elementImage",style:(_vm.styleImg),attrs:{"alt":"Images","src":_vm.getImageByID(_vm.id)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }